import { agentCursorAnnotationTargets } from "@/lib/agent-annotation";
import type { AgentPresentation } from "@/lib/agent-presentation-types";
import { useCanvasStore } from "@/stores/canvas-store";
import { getWindowDisplayId } from "@/desktop/use-window-role";

/** Successful playback, rather than a tool invocation, grants answer ownership. */
export function completePresentationCallouts(
  presentation: AgentPresentation,
): void {
  if (!presentation.executionId) return;
  const displayId = getWindowDisplayId();
  const prefix = `${presentation.presentationId}:`;
  useCanvasStore.setState((state) => {
    const next = new Map(state.agentCursors);
    let changed = false;
    for (const [id, cursor] of next) {
      if (
        cursor.executionId !== presentation.executionId ||
        cursor.presentationDeliveryId !== presentation.presentationId
      )
        continue;
      let updated = false;
      const targets = agentCursorAnnotationTargets(cursor).map((target) => {
        if (
          target.executionId !== presentation.executionId ||
          (displayId != null && target.displayId !== displayId) ||
          !target.annotationId?.startsWith(prefix) ||
          target.dismissed ||
          target.callout?.role !== "answer" ||
          !target.callout.content.trim()
        )
          return target;
        updated = true;
        return { ...target, callout: { ...target.callout, delivered: true } };
      });
      if (!updated) continue;
      changed = true;
      next.set(id, {
        ...cursor,
        annotationTargets: targets,
        annotationTarget:
          targets.find(
            (target) =>
              target.annotationId === cursor.annotationTarget?.annotationId,
          ) ?? cursor.annotationTarget,
      });
    }
    return changed ? { agentCursors: next } : state;
  });
}
